/* Vitalis: collection page (sections/main-collection.liquid).
   - The filter bar draws its 1px line once it is stuck under the header.
   - Filter chips, sort and Clear are plain links (tag URLs and ?sort_by=), so they work
     without JS. With JS they swap the eyebrow, the bar and the grid in place: the page keeps
     its title and scroll, the new tiles fade in (Vitalis.reveal "swap"), focus stays on the
     control that was used, and Back / Forward walk the states.
   - Price sort follows the price each tile shows (data-price), as the mockup does. */
(function () {
  "use strict";
  var d = document;
  var busy = null;

  function $(sel, root) { return (root || d).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }
  function V() { return window.Vitalis || null; }

  function sortGrid(grid) {
    if (!grid) return;
    var key = grid.getAttribute("data-sort") || "";
    if (key.indexOf("price") !== 0) return;
    var dir = key === "price-descending" ? -1 : 1;
    $$(":scope > [data-price]", grid).sort(function (a, b) {
      return ((+a.getAttribute("data-price")) - (+b.getAttribute("data-price"))) * dir ||
        (+a.getAttribute("data-rank")) - (+b.getAttribute("data-rank"));
    }).forEach(function (el) { grid.appendChild(el); });
  }

  /* The bar's hairline, through its own sentinel just above it. */
  function watchBar(root) {
    var sentinel = $("[data-coll-sentinel]", root);
    if (!sentinel || !("IntersectionObserver" in window)) return;
    if (root._collIO) root._collIO.disconnect();
    var bar = $(".fbar", root);
    var top = bar ? parseFloat(getComputedStyle(bar).top) || 0 : 0;
    root._collIO = new IntersectionObserver(function (entries) {
      var e = entries[0];
      root._collStuck = !e.isIntersecting && e.boundingClientRect.top < top + 1;
      var b = $(".fbar", root);
      if (b) b.classList.toggle("is-stuck", root._collStuck);
    }, { rootMargin: "-" + (top + 1) + "px 0px 0px 0px" });
    root._collIO.observe(sentinel);
  }

  function swap(root, html, o) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var next = doc.querySelector('[data-coll="' + root.getAttribute("data-coll") + '"]') || doc.querySelector("[data-coll]");
    if (!next) return false;
    var active = d.activeElement;
    var key = active && active.closest && active.closest("[data-coll-nav]") ? active.getAttribute("data-key") : null;
    var barBefore = $(".fbar", root);
    var gridBefore = $("[data-coll-grid]", root);
    var keepScroll = o.scroll && barBefore && gridBefore &&
      gridBefore.getBoundingClientRect().top < barBefore.getBoundingClientRect().bottom;

    $$("[data-coll-swap]", root).forEach(function (el) {
      var fresh = next.querySelector('[data-coll-swap="' + el.getAttribute("data-coll-swap") + '"]');
      if (fresh) el.replaceWith(d.importNode(fresh, true));
    });
    if (doc.title) d.title = doc.title;

    var bar = $(".fbar", root);
    if (bar && root._collStuck) bar.classList.add("is-stuck");
    var grid = $("[data-coll-grid]", root);
    sortGrid(grid);

    /* If the reader was inside the grid, bring the new set to the top under the bar. */
    if (keepScroll && grid && bar) {
      var gap = grid.getBoundingClientRect().top - bar.getBoundingClientRect().bottom;
      window.scrollTo(0, Math.max(0, window.pageYOffset + gap - 24));
    }
    if (V() && grid) V().reveal.init(grid, "swap");

    /* Focus: the same control, or the first chip when the one used has gone (Clear). */
    if (key) {
      var same = $('[data-coll-nav][data-key="' + key + '"]', root);
      var target = same && same.getClientRects().length ? same : $(".fbar [data-coll-nav]", root);
      if (target) {
        target.focus({ preventScroll: true });
        for (var n = target.parentNode; n && n !== root; n = n.parentNode) {
          if (!same && n.scrollWidth > n.clientWidth) n.scrollLeft = 0;
        }
      }
    }
    var count = $("[data-coll-swap='eyebrow']", root);
    if (V() && count) V().announce(count.textContent.replace(/\s+/g, " ").trim());
    return true;
  }

  function go(root, url, o) {
    if (busy) busy.abort();
    var ctl = "AbortController" in window ? new AbortController() : null;
    busy = ctl;
    $$("[data-coll-swap='bar'], [data-coll-swap='results']", root).forEach(function (el) {
      el.classList.add("is-busy");
    });
    /* Section Rendering API: only this section's HTML comes back (a host that ignores
       section_id returns the whole page, which swap() reads the same way). */
    var base = url.split("#")[0];
    var src = base + (base.indexOf("?") < 0 ? "?" : "&") + "section_id=" + encodeURIComponent(root.getAttribute("data-coll"));
    return fetch(src, { credentials: "same-origin", signal: ctl ? ctl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        busy = null;
        if (!swap(root, html, o)) throw new Error("no section");
        if (o.push) history.pushState({ vitalisColl: true }, "", url);
      })
      .catch(function (err) {
        if (err && err.name === "AbortError") return;
        busy = null;
        window.location.href = url;          // fall back to a plain page load
      });
  }

  function init(scope) {
    $$("[data-coll]", scope || d).forEach(function (root) {
      sortGrid($("[data-coll-grid]", root));
      watchBar(root);
      if (root._collBound) return;
      root._collBound = true;
      root.addEventListener("click", function (e) {
        var a = e.target.closest && e.target.closest("a[data-coll-nav]");
        if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        if (!window.fetch || !window.DOMParser || !history.pushState) return;
        e.preventDefault();
        go(root, a.href, { push: true, scroll: true });
      });
    });
  }

  if (history.replaceState && !(history.state && history.state.vitalisColl)) {
    try { history.replaceState({ vitalisColl: true }, "", window.location.href); } catch (e) { /* ignore */ }
  }
  window.addEventListener("popstate", function (e) {
    if (!e.state || !e.state.vitalisColl) return;
    var root = $("[data-coll]");
    if (root) go(root, window.location.href, { push: false, scroll: false });
  });
  d.addEventListener("shopify:section:load", function (e) { init(e.target); });

  init(d);
})();
